import { ApiEditTraveler } from '@bhtp-client-api/edit';
import { ApiTraveler } from '@bhtp-client-api/base';
import { EmailGroup } from './email-group.model';
import { Address } from './address.model';
import { TravelerDetailViewModel, Mapper } from '@bhtp-client-web/component';

export class Traveler extends TravelerDetailViewModel {
    constructor(isPrimary: boolean) {
        super(isPrimary);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/traveler.model.ts